module.exports = __webpack_public_path__ + "img/ic_topics.fa21ae63.svg";